





























































import { Component, Vue, Prop } from "vue-property-decorator";
import ExpensesReportGraphEstimates from "../components/ExpensesReportGraphEstimates.vue";
import ExpensesReportGraphExpenses from "../components/ExpensesReportGraphExpenses.vue";
import {
  getExpensesReport,
  GetExpensesReportQuery
} from "../../api/expenses-report-api";
import { addMonths, format } from "date-fns";
import ExpensesReportPresentationModel from "../presenters/expenses-report-presentation-model";
import ExpensesReportTable from "../components/ExpensesReportTable.vue";
import SearchExpensesReportBar from "../components/SearchExpensesReportBar.vue";
import ExpensesReportDate from "../components/SalesReportDate.vue";

import PrintExpensesReport from "../components/PrintExpensesReport.vue";
import { GetSalesReportQueryDetails } from "../components/SalesReportQuery.vue";
import VPrintButton from "@/components/VPrintButton.vue";
import VToolbar from "@/components/V-Toolbar.vue";

@Component({
  components: {
    ExpensesReportGraphEstimates,
    ExpensesReportGraphExpenses,
    ExpensesReportTable,
    SearchExpensesReportBar,
    ExpensesReportDate,
    PrintExpensesReport,
    VToolbar,
    VPrintButton
  }
})
export default class ExpensesReportPage extends Vue {
  @Prop() projectId?: string;

  // TODO: DEV: (未調整: テンプレート内の関数) 請求レポート Sales > 経費レポート Expenses に修正
  report = new ExpensesReportPresentationModel();

  graph = {
    labels: [] as string[],
    estimates: [] as number[],
    expenses: [] as number[],
    others: 0 as number,
    colors: [] as string[]
  };

  searchOptions: GetExpensesReportQuery = {
    month: "",
    monthOptions: "",
    companyId: "",
    companyType: "",
    staffId: "",
    vendorId: ""
  };

  queryDetails: GetSalesReportQueryDetails = {
    companyName: "",
    companyTypeName: "",
    staffName: "",
    vendorName: "",
    periodName: ""
  };

  // 基本の色設定 ()
  colors: string[] = [
    "#ff6383",
    "#ff9f40",
    "#ffcd56",
    "#4bc0c0",
    "#059bff",
    "#9866ff",
    "#ffa3ee",
    "#c9cbcf"
  ];

  get projectName(): string | undefined {
    const p = this.$store.state.project;
    return p ? p.name : undefined;
  }

  get thisMonth(): string {
    return format(this.month, "yyyy 年 MM 月");
  }

  moveMonth(months: number) {
    this.month = addMonths(this.month, months);
    this.generate();
  }

  search() {
    this.generate();
  }

  protected created() {
    this.generate();
  }

  private month = new Date();

  async generate() {
    const report = await getExpensesReport({
      ...this.searchOptions,
      month: format(this.month, "yyyy-MM"),
      projectId: this.projectId
    });
    report.colors = this.colors;

    const labels = report.expenseImportantList.map(s => s.name);
    const estimates = report.expenseImportantList.map(s => s.estimate);
    const expenses = report.expenseImportantList.map(s => s.expense);
    const colors = this.colors;
    const others = report.others;
    labels.push("その他");
    estimates.push(report.othersEstimateTotal);
    expenses.push(report.othersExpenseTotal);
    this.graph = {
      labels,
      estimates,
      expenses,
      others,
      colors
    };

    this.report = new ExpensesReportPresentationModel(report);
  }

  print(): void {
    (this.$refs.printComponent as PrintExpensesReport).print();
  }
}
